<app-layout-crud-index
  [titulo]="title"
  [length]="length"
  [dataSource]="dataSource"
  [filterFields]="filterFields"
  [configColumns]="configColumns"
  [displayedColumns]="displayedColumns"
  (onChangePage)="changePage($event)"
  (onFilter)="filter($event)"
  (onSubmitAdvancedFilter)="submitAdvancedFilter($event)"
  (onOpenShow)="openShow($event)"
  (onOpenNew)="openNew($event)"
  (onOpenEdit)="openEdit($event)"
  (onOpenDelete)="openDelete($event)"
  (onResetFilter)="resetFilter()"

  

>
  <table-responsive
    table
    [length]="length"
    [insideTheMenu] = "['LockButton','DeleteButton','EditButton','ShowButton']"
    (changePage)="changePage($event)"
    (filter)="filter($event)"
    [displayedColumns]="displayedColumns"
    [dataSource]="dataSource"
    [configColumns]="configColumns"
    (openShow)="openShow($event)"
    (openNew)="openNew($event)"
    (openEdit)="openEdit($event)"
    (openDelete)="openDelete($event)"
    [showLock]="true"
    [lockProperty]="'isActive'"
    (lock)="lock($event)"
    (unlock)="unlock($event)"
    (onSelectionChange)="onSelectionChange($event)"
    [dataSource]="dataSource"
    [displayedColumns]="displayedColumns"
    [showDownload]="true"
    [downloadProperty]="'fileAttachment'"
    (download)="downloadFile($event)"
    (description)="showDescriptionFile($event)"
    [showDescription]="true"
    [descriptionProperty]="'fileDescription'"
    [dataSource]="dataSource"
    [showPlayButton]="true"
    [loadingDownloads]="loadingDownloads"
    [loadingProgress]="loadingProgress"
    [length]="length"
    [displayedColumns]="displayedColumns"
    [dataSource]="dataSource"
    [configColumns]="configColumns"
    (download)="($event)"
    (play)="handlePlay($event)"
    (cancelDownload)="cancelDownload($event)"
    [currentTab]="currentTab" 
    [userType]="userType"

    [isEditableShow]="permissionService.is(permissionService.systemActionRoles.MARKETING_EDIT_BUTTON_SHOW)"
    [isEditableEnabled]="permissionService.is(permissionService.systemActionRoles.MARKETING_EDIT_BUTTON_ENABLED)"

    [isDeletableShow]="permissionService.is(permissionService.systemActionRoles.MARKETING_DELETE_BUTTON_SHOW)"
    [isDeletableEnabled]="permissionService.is(permissionService.systemActionRoles.MARKETING_DELETE_BUTTON_ENABLED)"

  ></table-responsive>
  <div footer>
    <div fxFlex fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4">
      <div fxFlex></div>
      <div fxFlex>
        <button disabled class="action-button" mat-raised-button></button>
      </div>
      <div fxFlex>
        <button disabled class="action-button" mat-raised-button></button>
      </div>
      <div fxFlex>
        <button disabled class="action-button" mat-raised-button></button>
      </div>
      <div fxFlex></div>
    </div>
  </div>
</app-layout-crud-index>
